export default __webpack_public_path__ + "1.18.20/static/media/LibreDataShare_Japanese.504fe043.svg";